import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { RadioButton } from '@naf-simba/elements-radio-button';
import { Text } from '@naf/text';
import { isNotTransientProp } from '@lib/shouldForwardProp';
import { HR_COLOR } from '@styles/colors';

export const Wrapper = styled.div`
  margin: -${spacing.space40} 0 0;

  @media (max-width: ${breakpoints.s}) {
    margin-top: -${spacing.space24};
  }
`;

export const HRLine = styled.hr`
  border: 0;
  border-top: 3px solid ${HR_COLOR};
  width: 96px;
  margin: 0 0 ${spacing.space20};
  color: ${HR_COLOR};
`;

export const Title = styled(Text)`
  margin: 0;
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space16};
  margin-top: ${spacing.space32};
`;

export const OptionWrapper = styled.div`
  display: block;
`;

export const StyledRadioButton = styled(RadioButton, { shouldForwardProp: isNotTransientProp })<{
  $isSelected: boolean;
}>`
  margin: 0;

  & + span .radio-label {
    font-weight: ${({ $isSelected }) => ($isSelected ? 700 : 400)};
  }
`;

export const TextIfSelectedWrapper = styled.div`
  margin-top: 0;
  margin-left: ${spacing.space32};
  max-width: 66%;

  @media (max-width: ${breakpoints.s}) {
    max-width: 100%;
  }

  p:first-child {
    margin-top: 0;
  }
`;

export const DynamicFormWrapper = styled.div`
  margin-top: ${spacing.space48};
`;
